export const getViewAllPanelStyles = () => ({
  '@global': {
    '.side-panel-keyword-planner-view-all.panel-right .panel-content': {
      '& .panel-body': {
        width: 600,
        paddingLeft: 24,
        paddingRight: 24,
        display: 'flex',
        marginBottom: 65,
        '& .fui-FluentProvider': {
          width: '100%',
        },
      },
      '& .panel-header': {
        paddingLeft: 24,
      },
    },
  },
});
